<template>
	<div class="wrap">
		<!-- 面包屑导航区 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item class="test" :to="{ path: '/jianjie' }">集团简介设置</el-breadcrumb-item>
			<el-breadcrumb-item>添加子公司</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card>
			<el-form label-width="110px" :model="formData">
				<!-- :label-position="labelPosition" :model="formLabelAlign" -->
				<el-form-item label="权重">
					<el-input v-model="formData.weights" type="number"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="子公司图片">
					<!-- <el-input v-model="formData.picUrl"></el-input> -->
					<!-- v-model="formLabelAlign.name" -->
					<!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :limit="3">
						<el-button size="small" type="primary">点击上传</el-button><el-tag type="danger" style="margin-left: 20px;">注意：子公司的图片需是3张</el-tag>
					</el-upload> -->

					<el-upload class="upload-demo" :action="uploadUrl" :limit="3" :file-list="fileList" list-type="picture" :on-remove="onRemove"
					 :on-success="onSuccess">
						<el-button size="small" type="primary">点击上传图片</el-button>	<el-tag type="danger" style="margin-left: 20px;">子公司的图片需是三张！</el-tag>
					</el-upload><!-- :on-preview="handlePreview" :on-remove="handleRemove" -->

				</el-form-item>
				<el-form-item label="子公司标题">
					<el-input v-model="formData.title"></el-input><!-- v-model="formLabelAlign.region" -->
				</el-form-item>
				<el-form-item label="子公司简介">
					<el-input v-model="formData.jianjie"></el-input><!-- v-model="formLabelAlign.type" -->
				</el-form-item>
			</el-form>

			<el-button type="success" class="submitBtn" @click="submit">立即提交</el-button>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				formData: {
					title: '',
					jianjie: '',
					weights:''
				},
				fileList: [],
				fileList2: [],
				uploadUrl: this.$httpTitle + '/uploadImgQiniugroup?pathName=activityNewInfo'
			}
		},
		created() {

		},
		methods: {
			onRemove(file, fileList) {//fileList剩下的会打印出来 response字段
				console.log('onRemove=' + JSON.stringify(fileList))
				var newfileList=[]
				this.fileList2.forEach((item1, index1) => {
					fileList.forEach((item2, index2) => {
						if (item1 == item2.response) {
							/* this.fileList2.splice(index1, 1) */
							newfileList.push(item2.response)
						}
					})
				})
				this.fileList2 = newfileList
				var onRemove = [{
					"status": "success",
					"name": "logo2.jpg",
					"size": 9763,
					"percentage": 100,
					"uid": 1593413448274,
					"raw": {
						"uid": 1593413448274
					},
					"url": "blob:http://localhost:8080/a0cb1215-0a8e-43c5-be47-57f525bd01a5",
					"response": "activityNewInfo/5281cd84-d931-4597-9e12-278e97bb387a"
				}, {
					"status": "success",
					"name": "personsal.png",
					"size": 17889,
					"percentage": 100,
					"uid": 1593413480809,
					"raw": {
						"uid": 1593413480809
					},
					"url": "blob:http://localhost:8080/f3011856-ed73-42c3-a6d9-d40cfb910a5e",
					"response": "activityNewInfo/f6243afd-a20b-40d8-8fa4-82a6a65c2a2e"
				}]
			},
			onSuccess(res) {
				console.log('onSuccess=' + res)
				this.fileList2.push(res)
			},
			async submit() {
				var obj={};
				obj['name'] = this.formData.title;
				obj['introduction'] = this.formData.jianjie;
				if(obj.name=='' || obj.introduction==''){
					this.$message.error('标题或者简介不能为空！')
					return false
				}
				if(this.fileList2.length <= 0){
					this.$message.error('请上传子公司封面图！')
					return false
				}
				obj['weights'] = +this.formData.weights;
				obj['subsidiaryPicture'] = this.fileList2.join(',')
				console.log(JSON.stringify(obj))
				
				var res = await this.$http.post('/v1/official/manag/subsidiary/add',{
					request:obj
				})
				if(res.data.code == 0){
					 this.$message.success('添加成功');
					 this.$router.push({
						 path:'/jianjie'
					 })
				}else{
					this.$message.error(res.data.message)
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	.submitBtn {
		margin-left: 110px;
	}
</style>
